module.exports = __webpack_public_path__ + "img/ssa2.25b16aee.jpg";